import React, { useContext } from 'react';
import withStyles from 'isomorphic-style-loader/withStyles';
import cx from 'classnames';
import { Container } from 'react-bootstrap';
import SafetyGridSkeleton from '../../Skeleton/Home/SafetyGridSkeleton/SafetyGridSkeleton';
import HomeContext from '../../../routes/context/homeContext';
import { api, homepageUploadDir } from '../../../config';
import { getDynamicTitleByName, getDynamicTitleByLocale } from '../../../helpers/getDynamicTitle';
import s from './SafetyGrid.css';

const SafetyGrid = ({ currentLocale, dynamicHomePageSettings, skeletonLoading, activeCategories }) => {
  const homepage = useContext(HomeContext);

  const allAppSectionData = getDynamicTitleByName({
    dynamicHomePageSettings,
    name: 'safetyGridTitle1',
  });

  let appSectionData = getDynamicTitleByLocale({
    dynamicHomePageSettings: allAppSectionData,
    locale: currentLocale,
  });

  appSectionData = appSectionData?.length > 0 ? appSectionData[0] : allAppSectionData[0];
  if (skeletonLoading) {
    return (
      <SafetyGridSkeleton />
    )
  }

  return (
    <div className={cx(activeCategories?.results?.filter(item => item?.isPopular).length === 0 && s.noPopularLocationTop)}>
      <Container>
        <div className={cx(s.userAppBgWrapper)} style={{
          backgroundImage: `url(${api.apiEndpoint + homepageUploadDir + homepage.safetyGridImage4})`,
        }} >
          <div className={s.userAppRowGrid}>
            <div className={cx(s.userAppImageWrapper, 'userAppImageWrapperRTL')}>
              <img src={api.apiEndpoint + homepageUploadDir + homepage.safetyGridImage3} alt="Safety illustration" />
            </div>

            <div>
              <h2 className={s.userAppHeading}>{appSectionData?.value}</h2>
              <p className={s.userAppDesc}>{appSectionData?.description}</p>
              <div className={s.userAppBtnGroup}>
                <a href={homepage.safetyGridLink1} target="_blank" rel="noopener noreferrer" className={s.userAppBtnLink}>
                  <img src={api.apiEndpoint + homepageUploadDir + homepage.safetyGridImage1}
                    alt="App Store"
                  />
                </a>
                <a href={homepage.safetyGridLink2} target="_blank" rel="noopener noreferrer" className={s.userAppBtnLink}>
                  <img src={api.apiEndpoint + homepageUploadDir + homepage.safetyGridImage2}
                    alt="Google Play"
                  />
                </a>
              </div>
            </div>
          </div>
        </div>
      </Container>
    </div>
  );
};

export default withStyles(s)(SafetyGrid);
